(function () {
  // ----------------------------
  // Config
  // ----------------------------
  var FIELD_SEL = [
    'input',
    'select',
    'textarea',
    "input[type='search']",
    "input[type='tel']"
  ].join(',');

  var ERROR_CONTAINER_SEL =
    '.quote-error, .quote-redesign-error, .sme-error, .panel-error, [role="alert"], #startdate-validation-message, .error';

  var ERROR_MSG_NODE_WITH_ID =
    'p[id], span[id], li[id], div[id], [role="alert"][id], #startdate-validation-message';

  var ALWAYS_VISIBLE_IDS = [
    'startdate-validation-message',
    'errorCountryNotFound'
  ];

  var ACTIVE_CLASS = 'enabled';

  var ERROR_TO_FIELD = {
    'errorCountryNotFound': 'country',
    'errorNationalityRequiredPrimary': 'nationality',
    'errorNationalityInvalidPrimary': 'nationality',
    'errorConsentRequired': 'step-consent'
  };

  var WRAPPER_PREFERENCES = [
    '.quote__date-field-wrapper',
    '.title-wrapper',
    '.dd',
    '.mm',
    '.yyyy',
    '.country-selector',
    '.row-m-0',
    '.input-country-container',
    '.nationality-col',
    '.phone-number',
    '.country-code',
    '.inner-input-container',
    '.col-sm-6',
    '.col-xs-12',
    '.row',
    '.quote-input-container',
    '.primary-member-row',
    '.step-consent-div'

  ];

  var CTA_SEL = [
    '.cta-button',
    '.cta-button-country',
    '.cta-button-your-details',
    '.cta-add-member',
    '.tickbox-input-js',
    '.save-member button',
    '.continue-btn',
    '.tiered-benefits-table-see-plan-button__cta-text'
  ].join(',');

  var panelEl = document.getElementById('quote-redesign-right-panel-container');

  // ----------------------------
  // Helpers
  // ----------------------------
  function ensureId(el, prefix) {
    if (!el.id || el.id.trim() === '') {
      el.id = (prefix || 'err') + '-' + Math.random().toString(36).slice(2, 9);
    }
    return el.id;
  }

  function isMessageActive($msg) {
    var id = $msg.attr('id') || '';
    if (ALWAYS_VISIBLE_IDS.indexOf(id) !== -1) {
      return $msg.is(':visible');
    }
    if ($msg.hasClass(ACTIVE_CLASS)) {
      return true;
    }

    var forField = $msg.attr("data-error-for");
    if (forField) {
      var $input = $("#" + forField);
      if ($input.length && $input.hasClass("error")) {
        return true;
      }
    }

    return false;
  }

  function findNearestWrapperWithErrors($field) {
    if ($field.siblings(ERROR_CONTAINER_SEL + ',' + ERROR_MSG_NODE_WITH_ID).length) {
      return $field;
    }
    for (var i = 0; i < WRAPPER_PREFERENCES.length; i++) {
      var sel = WRAPPER_PREFERENCES[i];
      var $wrap = $field.closest(sel);
      if ($wrap.length && $wrap.find(ERROR_CONTAINER_SEL + ',' + ERROR_MSG_NODE_WITH_ID).length) {
        return $wrap;
      }
    }
    var $anc = $field.parents().filter(function () {
      return $(this).find(ERROR_CONTAINER_SEL + ',' + ERROR_MSG_NODE_WITH_ID).length > 0;
    }).first();
    return $anc.length ? $anc : $field.parent();
  }

  function getLabelIds($field) {
    var ids = [];
    var labelledby = ($field.attr('aria-labelledby') || '').trim();
    if (labelledby) {
      labelledby.split(/\s+/).forEach(function (id) { if (id) ids.push(id); });
    }

    var fid = $field.attr('id');
    if (fid) {
      $('label[for="' + fid + '"]').each(function () {
        if (this.id) ids.push(this.id);
      });
    }

    var $wrap = findNearestWrapperWithErrors($field);
    $wrap.find('[id]').each(function () {
      var id = this.id;
      if (/label/i.test(id)) ids.push(id);
    });

    return Array.from(new Set(ids));
  }

  function collectActiveErrorIds($field) {
    var fieldId = $field.attr("id") || "";
    if (!$field.hasClass("error")) {
      return [];
    }
    var ids = [];
    var $direct = fieldId ? $('[data-error-for="' + fieldId + '"]') : $();
    $direct.each(function () {
      var $msg = $(this);
      if (isMessageActive($msg)) {
        ids.push(ensureId(this, "err"));
      }
    });
    // If direct mappings found → return them (these override everything).
    if ($direct.length > 0) {
      return Array.from(new Set(ids));
    }

    var $wrapper = findNearestWrapperWithErrors($field);
    var $candidates = $()
      .add($field.siblings(ERROR_CONTAINER_SEL))
      .add($field.siblings(ERROR_MSG_NODE_WITH_ID))
      .add($wrapper.find(ERROR_CONTAINER_SEL))
      .add($wrapper.find(ERROR_MSG_NODE_WITH_ID));

    var $activeMsgs = $();
    $candidates.each(function () {
      var $el = $(this);

      if ($el.is(ERROR_MSG_NODE_WITH_ID) && isMessageActive($el)) {
        $activeMsgs = $activeMsgs.add($el);
      }
      // children
      $el.find(ERROR_MSG_NODE_WITH_ID).each(function () {
        var $m = $(this);
        if (isMessageActive($m)) {
          $activeMsgs = $activeMsgs.add($m);
        }
      });
    });

    //
    // 4. Apply AUTO-DETECTION FILTERS (DOB, country, phone, etc.)
    //
    (function autoFilter() {
      var fid = fieldId.toLowerCase();
      var isDob = fid.match(/^(dd|mm|yyyy|day|month|year)/) ||
        $field.closest(".dd, .mm, .yyyy, .day, .month, .year, .quote__date-field-wrapper").length > 0;

      var isName = fid.includes("name") ||
        $field.closest(".name, .firstname, .lastname").length > 0;

      var isCountry = fid.includes("country") ||
        $field.closest(".country-selector, .input-country-container").length > 0;

      var isNationality = fid.includes("nationality") ||
        $field.closest(".nationality-col").length > 0;

      var isPhone = fid.includes("phone") || fid.includes("tel") ||
        $field.closest(".phone-number, .contact-number, .country-code").length > 0;

      var isEmail = fid.includes("email");
      var isRelationship = fid.includes("relationship") ||
        $field.closest(".relationship").length > 0;

      $activeMsgs = $activeMsgs.filter(function () {
        var id = (this.id || "").toLowerCase();

        if (isDob) {
          const isDobError =
            /(dob|day|month|year)/.test(id);

          const isAgeError =
            /(under|over|age)/.test(id) &&
            (this.getAttribute("data-error-for") === "dobGroup" || this.getAttribute("data-error-for") === "dobGroup1") &&
            this.classList.contains("enabled");

          return isDobError || isAgeError;
        }
        if (isName) return /name|firstname|lastname/.test(id);
        if (isCountry) return /country/.test(id);
        if (isNationality) return /nationality/.test(id);
        if (isPhone) return /phone|tel|contact/.test(id);
        if (isEmail) return /email|mail/.test(id);
        if (isRelationship) return /relationship|relation/.test(id);

        return true;
      });
    })();
    // -------------------------------------------------------------------

    if (fieldId) {
      $activeMsgs = $activeMsgs.filter(function () {
        var msgId = this.id || "";
        var mapped = ERROR_TO_FIELD[msgId];
        return !mapped || mapped === fieldId;
      });
    }

    $($.unique($activeMsgs.get())).each(function () {
      ids.push(ensureId(this, "err"));
    });

    return Array.from(new Set(ids));
  }

  function syncField($field) {
    setTimeout(function () {
      var STATIC_KEY = 'aria-describedby-static';

      var staticIds = $field.data(STATIC_KEY);
      if (staticIds === undefined) {
        staticIds = ($field.attr('aria-describedby') || '').trim();
        $field.data(STATIC_KEY, staticIds);
      }
      var staticList = staticIds ? staticIds.split(/\s+/).filter(Boolean) : [];

      var labelIds = getLabelIds($field);
      staticList = staticList.filter(function (id) { return labelIds.indexOf(id) === -1; });

      var errorIds = collectActiveErrorIds($field);

      if (errorIds.length) $field.attr('aria-invalid', 'true');
      else $field.removeAttr('aria-invalid');

      var finalIds = staticList.concat(errorIds)
        .filter(Boolean)
        .filter(function (v, i, a) { return a.indexOf(v) === i; });

      if (finalIds.length) $field.attr('aria-describedby', finalIds.join(' '));
      else $field.removeAttr('aria-describedby');
    }, 500);
  }

  function syncAllAria(root) {
    var $root = root ? $(root) : $(document);
    $root.find(FIELD_SEL).each(function () { syncField($(this)); });
  }

  window.syncAllAria = syncAllAria;

  ['input', 'change', 'focusout'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      try { syncAllAria(document); } catch (e) { }
    }, true);
  });

  document.addEventListener('click', function (e) {
    var node = e.target && e.target.closest ? e.target.closest(CTA_SEL) : null;
    if (node) {
      try { syncAllAria(document); } catch (e) { }
      setTimeout(function () { try { syncAllAria(document); } catch (e) { } }, 0);
    }
  }, true);

  $(document)
    .off('.a11ySync')
    .on('focusout.a11ySync change.a11ySync input.a11ySync', FIELD_SEL, function () {
      try { syncAllAria(document); } catch (e) { }
    })
    .on('click.a11ySync', CTA_SEL, function () {
      try { syncAllAria(document); } catch (e) { }
      setTimeout(function () { try { syncAllAria(document); } catch (e) { } }, 0);
    });

  $(document)
    .off('ajaxComplete.a11ySync')
    .on('ajaxComplete.a11ySync', function () {
      panelEl = document.getElementById('quote-redesign-right-panel-container') || panelEl;
      try { syncAllAria(panelEl || document); } catch (e) { }
    });

  var mo = null;
  function startObserver() {
    try {
      if (mo) mo.disconnect();
      var root = document.body || document.documentElement;
      mo = new MutationObserver(function () {
        try { syncAllAria(panelEl || document); } catch (e) { }
      });
      mo.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    } catch (e) { }
  }
  function stopObserver() { try { if (mo) mo.disconnect(); } catch (e) { } mo = null; }

  window.addEventListener('pagehide', stopObserver, { once: true });
  window.addEventListener('beforeunload', stopObserver, { once: true });

  $(function () {
    startObserver();
    try { syncAllAria(document); } catch (e) { }
  });
})();